// src/pages/PokemonPond.jsx
import React from "react";
import GameMap from "./logic/GameMap";
import { mapConfigs } from "./MapConfig/mapConfigs";

export default function PokemonPond() {
  return <GameMap config={mapConfigs.pond} />;
}